var ChatSocketEvents;
(function (ChatSocketEvents) {
    ChatSocketEvents["SendMessage"] = "SendMessage";
    ChatSocketEvents["ReceiveMessage"] = "ReceiveMessage";
    ChatSocketEvents["GetChatHistory"] = "GetChatHistory";
    ChatSocketEvents["GetChatHistoryResult"] = "GetChatHistoryResult";
    ChatSocketEvents["UpdateAdditionalData"] = "UpdateAdditionalData";
    ChatSocketEvents["JoinRoom"] = "JoinRoom";
    ChatSocketEvents["LeaveRoom"] = "LeaveRoom";
})(ChatSocketEvents || (ChatSocketEvents = {}));

export { ChatSocketEvents };
